export default {
	props: {
		/**
		 * The Button component has an appearance property with 3 available values: default, primary, minimal.
		 */
		appearance: {
			type: String,
			default: 'default',
			validator: function(value) {
				// The value must match one of these strings
				return [ 'default', 'primary', 'minimal', 'transparent', 'nav' ].indexOf(value) !== -1;
			}
		},
		/**
		 * The intent property is a slightly abstract API that maps to the following values: success, warning, danger
		 */
		intent: {
			type: String,
			default: 'default',
			validator: function(value) {
				// The value must match one of these strings
				return [ 'default', 'success', 'warning', 'danger' ].indexOf(value) !== -1;
			}
		},
		/**
		 * Makes the button element disabled.
		 */
		disabled: {
			type: Boolean,
			default: false,
		},
		/**
		 * Makes the button element disabled without the cursor changing.
		 */
		busy: {
			type: Boolean,
			default: false,
		},
		/**
		 * The Size property sets the size of the button. Available values: `x-small, small, medium, large`.
		 */
		size: {
			type: String,
			default: 'medium',
			validator: function(value) {
				// The value must match one of these strings
				return [ 'x-small', 'small', 'medium', 'large' ].indexOf(value) !== -1;
			}
		},
		/**
		 * The iconSize property sets the size of the icon. Available values: `x-small, small, medium, large`.
		 */
		iconSize: {
			type: String,
			default: 'small'
		},
		/**
		 * The shape property sets the shape of the button. Available values: `default, circle`.
		 */
		shape: {
			type: String,
			default: 'default',
			validator: function(value) {
				// The value must match one of these strings
				return [ 'default', 'circle' ].indexOf(value) !== -1;
			}
		},

		preventFocusOnClick: {
			type: Boolean,
			default: false
		}

	},
	methods: {
		onClick(event) {
			if (!this.preventFocusOnClick) {
				this.focus();
			}

			/**
			 * Event will be triggered after click on a button
			 * @event click
			 * @type {object}
			 */
			this.$emit('click', event);
		},
		onMouseDown(event) {
			/**
			 * Event will be triggered on mouse down
			 * @event mousedown
			 * @type {object}
			 */
			event.preventDefault();
			this.$emit('mousedown', event);
		},
		onFocus(event) {
			/**
			 * Fired when button gets focus.
			 * @event focus
			 * @type {object}
			 */
			this.$emit('focus', event);
		},
		onBlur(event) {
			/**
			 * Fired when button looses focus.
			 * @event blur
			 * @type {object}
			 */
			this.$emit('blur', event);
		},
		onKeydown(event) {
			/**
			 * Event will be triggered on key down
			 * @event keydown
			 * @type {object}
			 */
			this.$emit('keydown', event);
		},
		focus() {
			this.$refs.button.focus();
		}
	}
};
